
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IDrag } from "./interface";

@Component
export default class UiLoaderComponent extends Vue {
  @Prop() count: number;
  @Prop() loading: boolean;

  created() {}
  mounted() {}
}
